import { render, staticRenderFns } from "./headMenu1.vue?vue&type=template&id=b6c6f36a&scoped=true"
import script from "./headMenu1.vue?vue&type=script&lang=js"
export * from "./headMenu1.vue?vue&type=script&lang=js"
import style0 from "./headMenu1.vue?vue&type=style&index=0&id=b6c6f36a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c6f36a",
  null
  
)

export default component.exports